import React, { useEffect, useState } from "react";
import { ScrollView } from "react-native";
import { Block } from "@block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import { RouteProp, StackActions, useNavigation, useRoute } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ScreenNameType from "@navigation/nav-screens";
import { ACCOUNT } from "app/shared/services/services-model.type";
import FormTermDepositStatement from "./form-term-deposit-statement/form-term-deposit-statement.web";
import SourceTermDepositStatement from "./source-term-deposit-statement/source-term-deposit-statement.web";
import { fetchTermDepositListStatementRequest, fetchTermDepositStatementCreateRequest, setTermStatementReset } from "../reducer/actions";
import { getTermDepositListStatementSelector, getTermDepositStatementSelector } from "../reducer/selectors";
import { Constant } from "app/shared/constant/constant";
import { DataTermDepositStatement } from "../reducer/types";
import StackParamsList from "app/navigation/nav-stack-params";
// import { showModal } from "app/modules/modal-management/reducer/action";
// import { getTermDepositBranchName, getTermDepositProductName } from "../../term-deposit-utils/term-deposit.utils";
import { pushCleverTapEvent } from "app/shared/util/app-flyer";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";

type ProfileScreenRouteProp = RouteProp<StackParamsList, ScreenNameType.TERM_DEPOSIT_STATEMENT_CREATE>;

const TermDepositStatement = () => {
  const dispatchStore = useDispatch();
  const { dispatch, navigate } = useNavigation();
  const isDesktop = useDesktopMediaQuery();
  const { t } = useTranslation();

  const { params } = useRoute<ProfileScreenRouteProp>();

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        eventPushCleverTap(false);
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: t("FUNC_TIET_KIEM"),
      onPressSubtitle: () => {
        eventPushCleverTap(false);
        dispatch(StackActions.replace(ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT));
      },
    },
    {
      name: t("FUNC_TAT_TOAN_STK"),
      onPressSubtitle: () => {},
    },
  ];

  const routeProps = useRoute<ProfileScreenRouteProp>();
  const termStatementStore = useSelector(getTermDepositStatementSelector);
  const listStatementStore = useSelector(getTermDepositListStatementSelector);

  const [accountDebit, setAccountDebit] = useState<ACCOUNT>({});
  const [accountCredit, setAccountCredit] = useState<ACCOUNT>({});
  const [isValidDebit, setIsValidDebit] = useState(false);
  const [isValidCredit, setIsValidCredit] = useState(false);
  const [isAccountDebitDefault, setIsAccountDebitDefault] = useState(false);
  const [isAccountCreditDefault, setIsAccountCreditDefault] = useState(false);
  const [isSetParam, setIsSetParam] = React.useState<boolean>(false);
  const contactId = useSelector(getContactIdSelector);

  const [isSubmit, setIsSubmit] = useState(false);

  const eventPushCleverTap = (status: boolean, response?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(status, response);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const onCancel = () => {
    eventPushCleverTap(false);
    dispatch(StackActions.replace(ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT));
  };

  // Submit Create
  const onSubmit = () => {
    setIsSubmit(true);
  };

  const onChangeAccountDebit = (account: ACCOUNT, isValid: boolean) => {
    setIsAccountDebitDefault(false);
    setAccountDebit(account);
    setIsValidDebit(isValid);
  };
  const onChangeAccountCredit = (account: ACCOUNT, isValid: boolean) => {
    setIsAccountCreditDefault(false);
    setAccountCredit(account);
    setIsValidCredit(isValid);
  };

  const requestCreate = () => {
    if (isValidDebit && isValidCredit) {
      const dataNew: DataTermDepositStatement = {
        ACCOUNT_DEBIT: accountDebit,
        ACCOUNT_CREDIT: accountCredit,
      };
      dispatchStore(fetchTermDepositStatementCreateRequest(dataNew));
    }
  };

  const nextConfirm = React.useCallback(() => {
    navigate(ScreenNameType.TERM_DEPOSIT_STATEMENT_CONFIRM);
  }, [navigate]);

  // const checkInfoPromotions = React.useCallback(
  //   (data?: EBACCOUNTDEPOSITS) => {
  //     if (!data) return true;
  //     const promotion = data?.PROMOTIONS;
  //     if (promotion && promotion === "Y") {
  //       const msg = t("SAVING_PROPMOTION_FINALIZATION_MESSAGE").replace("{event_name}", '"' + t("SAVING_PROMOTION_EVENT_NAME") + '"');
  //       dispatchStore(
  //         showModal({
  //           modalType: "multiAction",
  //           modalProps: {
  //             open: true,
  //             message: msg,
  //             acceptModal: () => {
  //               console.log("acceptModal");
  //               nextConfirm();
  //             },
  //           },
  //         }),
  //       );
  //     } else {
  //       console.log("vào đây: ");
  //       nextConfirm();
  //     }
  //   },
  //   [dispatchStore, nextConfirm, t],
  // );

  const handlerParamsCleverTap = (status: boolean, response?: string) => {
    console.log("handlerParamsCleverTap");
    let param = {};
    let term = termStatementStore.dataCreate?.ACCOUNT_DEBIT?.FDTERM || "";
    if (term !== "") {
      term = term.replace("-", "");
    }
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_cta: status ? "Tiếp tục" : "Hủy",
      ct_final_settlement_product: termStatementStore.dataCreate?.ACCOUNT_DEBIT?.PRODUCTCODE,
      ct_final_settlement_term: term,
      ct_final_settlement_total_amount: termStatementStore.dataCreate?.ACCOUNT_DEBIT?.CURRENTBALANCE || "",
      ct_final_settlement_branch: termStatementStore.dataCreate?.ACCOUNT_DEBIT?.BRANCH_CODE || "",
    };
    if (response) {
      param = {
        ...param,
        ct_final_settlement_status: response || "",
      };
    }

    return {
      eventNameCT: "ct_final_settlement",
      paramsCT: param,
    };
  };

  useEffect(() => {
    console.log("Khởi tạo");
    if (routeProps?.params?.resetData === true) {
      dispatchStore(setTermStatementReset());
      dispatchStore(fetchTermDepositListStatementRequest());
    }
  }, [dispatchStore, routeProps?.params?.resetData]);

  useEffect(() => {
    if (isSubmit) setIsSubmit(false);
  }, [isSubmit]);

  useEffect(() => {
    if (listStatementStore?.LIST_ACCOUNT_PROFILE?.ACCOUNT.length && params?.account && !isSetParam) {
      setIsSetParam(true);
      const filters: ACCOUNT[] = listStatementStore?.LIST_ACCOUNT_PROFILE?.ACCOUNT.filter((_account) => {
        return _account.ACCOUNTNO === params?.account?.ACCOUNTNO;
      });
      if (filters.length) {
        setIsAccountDebitDefault(true);
        setAccountDebit(params?.account);
      }
    }
  }, [isSetParam, listStatementStore, params?.account]);

  useEffect(() => {
    if (termStatementStore.isCreated) {
      eventPushCleverTap(true, "success");
      nextConfirm();
      // checkInfoPromotions(termStatementStore.responseCreate?.EBACCOUNT_DEPOSITS);
      // navigate(ScreenNameType.TERM_DEPOSIT_STATEMENT_CONFIRM);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termStatementStore.isCreated, termStatementStore.responseCreate?.EBACCOUNT_DEPOSITS]);

  useEffect(() => {
    if (termStatementStore.statusCreate === "pending") {
      eventPushCleverTap(true);
    }
    if (termStatementStore.statusCreate === "error") {
      eventPushCleverTap(true, "failure" + (termStatementStore.errorMsg || ""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termStatementStore.statusCreate]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("FUNC_TAT_TOAN_STK")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          <StepProcessUniversal currentSteps={0} />
          <SourceTermDepositStatement
            typeArray={[Constant.ACCOUNTTYPE.ACCOUNT_PAYMENT]}
            isSubmit={isSubmit}
            accountDebit={accountDebit}
            accountCredit={accountCredit}
            onChangeDebit={onChangeAccountDebit}
            onChangeCredit={onChangeAccountCredit}
            isAccountCreditDefault={isAccountCreditDefault}
            isAccountDebitDefault={isAccountDebitDefault}
          />
          <FormTermDepositStatement accountDebit={accountDebit} onSubmit={onSubmit} onCancel={onCancel} requestCreate={requestCreate} />
        </Block>
      </ScrollView>
    </Block>
  );
};

export default TermDepositStatement;
